import "./DismissableLayer_module.css";
const DismissableLayer_module_rslib_entry_ = {
    DismissableLayer: "DismissableLayer-taKNAQ",
    dismissableLayer: "DismissableLayer-taKNAQ"
};
export { DismissableLayer_module_rslib_entry_ as default };

//# sourceMappingURL=DismissableLayer.module.js.map